import { useMemo } from 'react';
import cn from 'classnames';
import { dataTableStyles } from '@creditflowresearch/uilib/Table/DataTable';
import { ExpandableTable } from '@creditflowresearch/uilib/Table/ExpandableTable';
import { IColumn } from '@creditflowresearch/uilib/Table/DataTable/interfaces/Column';
import Paginator from '@creditflowresearch/uilib/Paginator';
import { DEFAULT_EMPTY_MESSAGE } from '@framework/ui/Molecules/Tables/constants';
import { useStatsContext } from '@/creditflowresearch/application/ArticlesAndStats/Stats/StatsContext';
import { useHeaderMenuContext } from '@/creditflowresearch/application/HeaderMenu/HeaderMenuContext';
import TableWrapper from '@framework/ui/Molecules/Tables/TableWrapper';
import { getStatsDataForView } from './helpers';
import StatExpandedData from './StatExpandedData';

import styles from './styles.module.scss';

interface IStatsTableProps {
  columns: IColumn[],
}

const StatsTable = ({ columns }: IStatsTableProps) => {
  const { regions: regionsList, products: productsList } = useHeaderMenuContext();
  const {
    statsCollection: {
      collection,
      isFetching,
      page,
      perPage,
      totalCount,
      paginate,
    },
    mapCategories,
    isExpanded,
  } = useStatsContext();

  const data = useMemo(
    () => getStatsDataForView(collection, mapCategories, regionsList, productsList),
    [collection, mapCategories, regionsList, productsList],
  );

  return (
    <TableWrapper className={ styles.tableWrapper }>
      <ExpandableTable
        dataTest="statsDataTable"
        collection={ data }
        columns={ columns }
        className={ cn(dataTableStyles.isHoverable, styles.statsTable) }
        isFetching={ isFetching }
        emptyCollectionMessage={ isFetching ? '' : DEFAULT_EMPTY_MESSAGE }
        isRowsExpanded={ isExpanded }
        expandableRowContent={ StatExpandedData }
        expandCollapseOnRowClick={ false }
      />
      <Paginator
        dataTest="statsDataTablePagination"
        page={ page }
        perPage={ perPage }
        totalCount={ totalCount }
        isItemsPerPageVisible={ false }
        onPageChange={ ({ selected }) => paginate(selected) }
      />
    </TableWrapper>
  );
};

export default StatsTable;
